import { API_BASE } from "../config";
import React, { useState, useEffect } from 'react';
import PersonalHistoryModal from './PersonalHistoryModal';
import ParentalHistoryModal from './ParentalHistoryModal';
import PersonalHistoryView from './PersonalHistoryView';
import ParentalHistoryView from './ParentalHistoryView';

const MedicalHistorySection = ({ fetchWithAuth }) => {
  const [showPersonalModal, setShowPersonalModal] = useState(false);
  const [showParentalModal, setShowParentalModal] = useState(false);
  const [showPersonalView, setShowPersonalView] = useState(false);
  const [showParentalView, setShowParentalView] = useState(false);
  const [personalHistoryData, setPersonalHistoryData] = useState(null);
  const [parentalHistoryData, setParentalHistoryData] = useState(null);

  useEffect(() => {
    loadMedicalHistoryData();
  }, []);

  const loadMedicalHistoryData = async () => {
    try {
      const [personalRes, parentalRes] = await Promise.all([
        fetchWithAuth(`${API_BASE}/api/medical-history/personal`),
        fetchWithAuth(`${API_BASE}/api/medical-history/parental`)
      ]);

      const personalData = await personalRes.json();
      const parentalData = await parentalRes.json();

      setPersonalHistoryData(personalData);
      setParentalHistoryData(parentalData);
    } catch (error) {
      console.error('Failed to load medical history data:', error);
    }
  };

  const handlePersonalHistorySave = async (data) => {
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/medical-history/personal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        const updatedData = await response.json();
        setPersonalHistoryData(updatedData);
        setShowPersonalModal(false);
        loadMedicalHistoryData(); // Reload to refresh buttons
      }
    } catch (error) {
      console.error('Failed to save personal history:', error);
    }
  };

  const handleParentalHistorySave = async (data) => {
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/medical-history/parental`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        const updatedData = await response.json();
        setParentalHistoryData(updatedData);
        setShowParentalModal(false);
        loadMedicalHistoryData(); // Reload to refresh buttons
      }
    } catch (error) {
      console.error('Failed to save parental history:', error);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Medical History</h3>
      </div>

      <div className="card-body">
        <p className="mhs-description">Manage your personal and family medical history to help with personalized nutrition recommendations.</p>

        <div className="mhs-grid">
          {/* Personal History */}
          <div className="mhs-historyCard">
            <h4 className="mhs-historyTitle">Personal History</h4>
            <p className="mhs-historyDesc">Your own medical conditions and diagnoses</p>
            <div className="mhs-historyActions">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => setShowPersonalModal(true)}
              >
                Edit
              </button>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setShowPersonalView(true)}
              >
                View
              </button>
            </div>
          </div>

          {/* Parental History */}
          <div className="mhs-historyCard">
            <h4 className="mhs-historyTitle">Parental History</h4>
            <p className="mhs-historyDesc">Family medical history from parents</p>
            <div className="mhs-historyActions">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => setShowParentalModal(true)}
              >
                Edit
              </button>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setShowParentalView(true)}
              >
                View
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modals */}
      <PersonalHistoryModal
        isOpen={showPersonalModal}
        onClose={() => setShowPersonalModal(false)}
        onSave={handlePersonalHistorySave}
        existingData={personalHistoryData}
      />

      <ParentalHistoryModal
        isOpen={showParentalModal}
        onClose={() => setShowParentalModal(false)}
        onSave={handleParentalHistorySave}
        existingData={parentalHistoryData}
      />

      {/* View Modals */}
      <PersonalHistoryView
        isOpen={showPersonalView}
        onClose={() => setShowPersonalView(false)}
        data={personalHistoryData}
      />

      <ParentalHistoryView
        isOpen={showParentalView}
        onClose={() => setShowParentalView(false)}
        data={parentalHistoryData}
      />
    </div>
  );
};

export default MedicalHistorySection;